import { IconArrowUp, IconBrandYoutube } from '@tabler/icons-react';

import { Badge } from '@/components/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePollHorizontal } from '@fortawesome/free-solid-svg-icons';
import themeVariables from '@/styles/themeVariables';

export const PopularBadge = () => (
  <Badge
    text={'인기 급상승'}
    color={themeVariables.colors.blue200}
    backgroundColor={themeVariables.colors.blue100}
    icon={
      <IconArrowUp color={themeVariables.colors.blue200} size={13} stroke={3} />
    }
  />
);

export const QuizBadge = () => (
  <Badge
    text={'퀴즈'}
    color={themeVariables.colors.blue200}
    backgroundColor={themeVariables.colors.blue100}
    icon={
      <FontAwesomeIcon
        icon={faSquarePollHorizontal}
        style={{ verticalAlign: 'text-top' }}
      />
    }
  />
);

export const VideoBadge = () => (
  <Badge
    text={'영상'}
    color={themeVariables.colors.blue200}
    backgroundColor={themeVariables.colors.blue100}
    icon={
      <IconBrandYoutube
        color={themeVariables.colors.blue200}
        size={13}
        stroke={3}
      />
    }
  />
);
